<p-confirmDialog
    [baseZIndex]="10000"
></p-confirmDialog><!-- <p-confirmDialog #cd [style]="{width: '50vw'}" [closable]="false">    <ng-template pTemplate="header">        <h3>Confirmation</h3>    </ng-template>    <ng-template pTemplate="footer">        <button type="button" pButton icon="pi pi-times" class="p-button-outlined" label="No" (click)="cd.reject()"></button>        <button type="button" pButton icon="pi pi-check" class="p-button-danger p-button-outlined" label="Yes" (click)="cd.accept()"></button>    </ng-template></p-confirmDialog> -->
<ngx-spinner
    bdColor="rgba(0, 0, 0, 0.8)"
    size="default"
    style="z-index: 999999999999999"
    color="#1429EF"
    type="square-jelly-box"
    [fullScreen]="true"
>     <div style="color: white; text-align: center;">
        <div style="font-weight: 700; letter-spacing: 0.4px; font-size: 15px;">Please wait...</div>
        <!-- <div style="opacity: 0.8; font-size: 12px; margin-top: 6px;">Pulling your data—this will just take a moment.</div> -->
    </div></ngx-spinner
    ><p-toast position="bottom-center"></p-toast><router-outlet></router-outlet>

<div *ngIf="singleTabGuard.blocked"
    class="flex flex-column align-items-center justify-content-center text-center p-4"
    style="position: fixed; inset: 0; z-index: 2000000000; background: #fff;">
    <i class="pi pi-clone text-5xl mb-3" style="color: var(--brandColor)"></i>
    <h3 class="m-0 mb-2">This page is open in another tab</h3>
    <p class="m-0 mb-4 text-color-secondary">A product is being edited in another tab. Please continue there.</p>
    <button pButton type="button" label="Close this tab" (click)="singleTabGuard.closeThisTab()"></button>
</div>

    <!-- color="var(--primary-color)" -->

<!-- <ng-container *ngIf="_userService.isCheckIn && !_abd.isAdmin">
<p-dialog [(visible)]="_userService.isCheckIn" [showHeader]="false" [modal]="true" 
[dismissableMask]="false" [focusTrap]="true" [draggable]="false" 
[style]="{width: '30%'}">
<app-time-attendance *ngIf="_userService.isCheckIn"></app-time-attendance>
</p-dialog>
</ng-container> -->
<p-dialog
    header="Inactivity Alert!"
    [closable]="false"
    [modal]="true"
    [(visible)]="displayUserInactivity"
     [style]="{ width: '25vw' }"
        [breakpoints]="{ '1300px': '80vw', '640px': '100vw' }"
>    <div class="flex justify-content-center">        <div
            class="flex align-items-center justify-content-center text-orange-500 text-xl font-bold m-2"
        >            AUTO LOGOUT IN
        </div>    </div>    <div class="flex justify-content-center">        <div
            class="flex align-items-center justify-content-center text-6xl font-bold text-red-600 m-2"
        >            {{ userDialogTimer }}
        </div>    </div>    <div class="flex justify-content-center">        <div
            class="flex align-items-center justify-content-center text-red-400 m-2"
        >            seconds
        </div>    </div>    <p-divider></p-divider>    <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-secondary"
        [style]="{ width: '100%' }"
        (click)="clearAutologoffHandle()"
    ></button></p-dialog>
    <!-- <div class="overlay" *ngIf="this._userService.isShowCheckIn" style=" 
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.32);
    z-index: 1099; 
    "></div> -->
